import React from 'react';
import { AlertTriangleIcon, CalendarCheckIcon, ClockIcon, CreditCardIcon } from 'lucide-react';
import { BookingCalendar } from './BookingCalendar';
const steps = [{
  icon: CalendarCheckIcon,
  title: 'Elegí día y hora',
  text: 'Seleccioná el servicio y el horario disponible en el calendario.'
}, {
  icon: CreditCardIcon,
  title: 'Pagá la seña del 50%',
  text: 'El pago se procesa automáticamente por Mercado Pago al agendar.'
}, {
  icon: ClockIcon,
  title: 'Recibí la confirmación',
  text: 'Una vez acreditado el pago te llega el turno confirmado con la dirección.'
}];
function MercadoPagoMark() {
  return <span className="inline-flex items-center gap-2 rounded-xl bg-[#009EE3] px-3 py-1.5" data-id="element-35" data-mp="1j9gdgcg7f7yn">
      <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden="true" fill="none" data-id="element-36" data-mp="1oavwy02qh6ex">
        <path d="M3 13.5c2.2-3.6 5.4-5.4 9.6-5.4 4.2 0 7.1 1.5 8.8 4.5-2 3.6-5 5.4-9 5.4-3.4 0-6.5-1.5-9.4-4.5Z" fill="white" data-id="element-37" data-mp="1abd2ub6rbvlm" />
        <circle cx="12" cy="13" r="2.1" fill="#009EE3" data-id="element-38" data-mp="1qx0jrhcbtzht" />
      </svg>
      <span className="text-xs font-bold tracking-wide text-white" data-id="element-39" data-mp="1qzd4u3ddspz3">Mercado Pago</span>
    </span>;
}
export function Booking() {
  return <section id="reservar" className="w-full bg-white py-20 sm:py-28" data-id="element-40" data-mp="20vq0h6shldwh">
      <div className="mx-auto w-full max-w-7xl px-5 sm:px-8" data-id="element-41" data-mp="1vwdcujtsk2su">
        <div className="max-w-2xl" data-id="element-42" data-mp="1vwwo5hoxrsxw">
          <p className="text-sm font-semibold text-rosegold-dark" data-id="element-43" data-mp="186sk597u5r6d">Agenda online</p>
          <h2 className="mt-3 font-serif text-4xl font-semibold leading-tight text-ink sm:text-5xl" data-id="element-44" data-mp="184g2kx5zpitu">
            Reservá tu turno
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-45" data-mp="1hwvi7nttdvbk">
            Agenda fácil, rápido y sin complicaciones. Elegí el horario que mejor te quede y listo.
          </p>
        </div>

        <div className="mt-12 grid gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-10" data-id="element-46" data-mp="pfj5ymn4ee8g">
          <div className="flex flex-col gap-6" data-id="element-47" data-mp="khhsch8gr74d">
            <div role="note" className="rounded-3xl border-2 border-fucsia-deep/35 bg-blush-100 p-6 sm:p-7" data-id="element-48" data-mp="kgonxmwz8tpe">
              <p className="flex items-center gap-2 font-serif text-xl font-semibold text-fucsia-ink" data-id="element-49" data-mp="2pi0vyb1h626t">
                <AlertTriangleIcon className="h-5 w-5" aria-hidden="true" data-id="element-50" data-mp="2u8r2hrln0b33" />
                Importante: seña del 50%
              </p>
              <p className="mt-3 text-[0.95rem] leading-relaxed text-ink" data-id="element-51" data-mp="2yacl7tkurjl7">
                Para confirmar tu turno se requiere el pago de una{' '}
                <strong className="font-semibold" data-id="element-52" data-mp="26joi4bzmc44w">seña del 50%</strong> vía Mercado Pago. El pago se
                procesa automáticamente al agendar y el turno queda confirmado una vez recibido.
              </p>
              <p className="mt-3 text-sm leading-relaxed text-ink-soft" data-id="element-53" data-mp="2fkw8m7vw80of">
                La seña se descuenta del total del servicio. Si necesitás reprogramar, avisame con
                24 horas de anticipación y la mantenemos para tu próximo turno.
              </p>
            </div>

            <ol className="flex flex-col gap-5 rounded-3xl border border-blush-200 bg-cream p-6 sm:p-7" data-id="element-54" data-mp="4xsz83v0xm9p">
              {steps.map((step, index) => <li key={step.title} className="flex gap-4" data-id="element-55" data-mp="3w4x2cno1socu" data-mpi={index}>
                  <span className="mt-0.5 inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-white text-fucsia-deep shadow-soft" data-id="element-56" data-mp="3rd5cyggmoooa">
                    <step.icon className="h-5 w-5" aria-hidden="true" data-id="element-57" data-mp="3n9z5j5hs4rg8" />
                  </span>
                  <div data-id="element-58" data-mp="3iaw03jxw0j7q">
                    <p className="font-semibold text-ink" data-id="element-59" data-mp="3ddvv7ccrxmi7">
                      <span className="mr-1.5 text-fucsia-deep" data-id="element-60" data-mp="3dcb27r63ybmg">{index + 1}.</span>
                      {step.title}
                    </p>
                    <p className="mt-1 text-sm leading-relaxed text-ink-soft" data-id="element-61" data-mp="34dh6s44ijrah">{step.text}</p>
                  </div>
                </li>)}
            </ol>

            <div className="flex flex-wrap items-center gap-3 rounded-3xl border border-blush-200 bg-blush-50 p-5" data-id="element-62" data-mp="16lbuznpuo7wd">
              <MercadoPagoMark data-id="element-63" data-mp="12jzyqzch0of7" />
              <p className="text-sm text-ink-soft" data-id="element-64" data-mp="19oretml8r3pn">
                Pago seguro con tarjeta de débito, crédito o dinero en cuenta.
              </p>
            </div>
          </div>

          {/* Selector propio: foto de Camila → meses → días → horarios (se sincroniza con Calendly) */}
          <BookingCalendar data-id="element-65" data-mp="14petx7dxk6pp" />
        </div>
      </div>
    </section>;
}